import type { HelpTopic } from '../core/index.js'

/** The scoring module's help topics (docs/plans/in-app-help-plan.md). */
export const SCORING_HELP_TOPICS: readonly HelpTopic[] = [
  {
    id: 'scoring.worker-home',
    title: 'Your score',
    seats: ['worker'],
    summary: 'Your reliability score and tier, what is moving them, and what you can do next.',
    sections: [
      {
        heading: 'Your score and tier',
        points: [
          'The dial shows your score this month, from 0 to 100.',
          'Your tier (Gold, Silver, Bronze or Probationary) changes only when the month closes.',
          '“On track for …” shows the tier your score would earn if the month closed today.',
        ],
      },
      {
        heading: 'What moves your score',
        points: [
          'Each bar is one thing your facility measures, such as arriving on time or calling out.',
          'The note under a bar says what earns full marks.',
          'Points count only for shifts you actually work, Clinical Bridge shifts included.',
          'Working a day your PTO was denied, or picking up a shift needed within 24 hours, adds points once you work it.',
        ],
      },
      {
        heading: 'What you can do here',
        points: [
          'Tell your manager what is getting in the way. They read it and can reply.',
          'Turn on alerts on this device to hear about open shifts and swaps.',
          'Tap History to see your past months.',
        ],
      },
    ],
    related: ['scoring.worker-history', 'messages.worker-barriers', 'messages.worker-contacts'],
  },
  {
    id: 'scoring.worker-history',
    title: 'Your score history',
    seats: ['worker'],
    summary: 'Your score month by month, so you can see where you have been and which way you are heading.',
    sections: [
      {
        heading: 'What you see',
        points: [
          'One dial per month. A closed month shows its final score; the month you are in shows its score so far.',
          'Tap a month to see the same bars as on Home for that month.',
        ],
      },
      {
        heading: 'Good to know',
        points: [
          'Each month stands alone. What happened last month does not count against this one.',
          'A month with no shifts has no score. It is not a zero, and your tier stays as it was.',
          'Your tier is set when a month closes, from that month’s final score.',
        ],
      },
    ],
    related: ['scoring.worker-home'],
  },
]
